import createTheme from '@material-ui/core/styles/createTheme';

const theme = createTheme({
  palette: {
    primary: {
      main: '#005b7f',
      dark: '#005b7f',
      light: '#3fa9f5',
    },
    secondary: {
      main: '#f6ab00',
      dark: '#f6ab00',
    },
    green: {
      main: '#97a728',
      dark: '#97a728',
    },
    white: {
      main: '#ffffff',
      dark: '#ffffff',
    },
    background: {
      default: '#fff',
    },
    action: {
      selected: 'rgb(0, 91, 127, 0.15)',
    },
    text: {
      primary: '#333333',
    },
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        fontWeight: 'bold',
      },
      containedSecondary: {
        color: 'white',
        fontWeight: 'bold',
      },
    },
    MuiAutocomplete: {
      option: {
        '&[data-focus="true"]': {
          backgroundColor: 'rgb(0, 0, 0, 0.09)',
        },
      },
    },
  },
});

export default theme;
